import React from 'react';
import PropTypes from 'prop-types';

const Image = (props) => {
  const { image, alt, offset } = props;

  return (
    <div className={`Image${offset ? ` Image--offset-${offset}` : ''}`}>
      <img className="Image__Image" src={image} alt={alt} />
    </div>
  );
};

Image.propTypes = {
  image: PropTypes.any.isRequired,
  offset: PropTypes.number,
  alt: PropTypes.any.isRequired,
};

Image.defaultProps = {
  offset: 0,
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.js